import React from 'react';
import { IBusinessProfile } from '../../../../../../../Interfaces/responseTypes';
import useLanguagesHooks from '../../../../../../../Components/Languages/setLanguage-hooks';
import { isBusinessClosed, isBusinessFreeDay } from '../../../../../../../Utilits/utilits';
import BusinessClosedNotice from '../BusinessClosedNotice/businessClosedNotice';
import styles from './orderScheduleNotices.module.scss';

interface IProps {
  profile?: IBusinessProfile | null;
  selectedDate?: string;
}

const OrderScheduleNotices: React.FC<IProps> = ({ profile, selectedDate }) => {
  const { t } = useLanguagesHooks();

  if (!profile) {
    return null;
  }

  const isClosed = isBusinessClosed(profile);
  const isSelectedClosedDay = Boolean(
    selectedDate && isBusinessFreeDay(selectedDate, profile.free_days),
  );

  if (!isClosed && !isSelectedClosedDay) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      {isClosed && <BusinessClosedNotice profile={profile} variant="order" />}
      {isSelectedClosedDay && (
        <p className={styles.closedDayNotice} role="alert">
          {t('Visitor.Order_Time.Day_Closed')}
        </p>
      )}
    </div>
  );
};

export default OrderScheduleNotices;
